<template>
  <div :class="style['number-counter']">
    <button type="button" @click.prevent="decreaseCount(index)">-</button>
    <span :class="style['number']">{{ count }}</span>
    <button type="button" @click.prevent="increaseCount(index)">+</button>
  </div>
</template>

<script>
import style from './scss/_counter.scss'

export default {
  data: () => ({ style }),
  props: {
    count: { type: Number, required: true },
    decreaseCount: { type: Function, required: true },
    increaseCount: { type: Function, required: true },
    index: { type: Number }
  }
}
</script>
